import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MedicoInconsistenciaResponse } from '@/core/api/sicom-api/registro/medico/inconsistencia/medico-inconsistencia.model';
import { MedicoInconsistenciaTotalUfResponse } from '@/core/api/sicom-api/registro/medico/inconsistencia/medico-inconsistencia-total-uf.model';
import { MedicoInconsistenciaService } from '@/core/api/sicom-api/registro/medico/inconsistencia/medico-inconsistencia.service';
import { MedicoPendenciaResponse } from '@/core/api/sicom-api/registro/medico/pendencia/medico-pendencia.model';
import { Page } from '@/shared/models/page.model';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class MedicoInconsistenciaFeatureService extends CustomService {
    constructor(private core: MedicoInconsistenciaService) {
        super();
    }

    listarPorUf(uf?: string | null): Observable<MedicoInconsistenciaResponse[]> {
        return this.core.listarPorUf(uf).pipe(catchError(this.handleError));
    }

    listarHistoricoPorUf(uf?: string | null): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        return this.core.listarHistoricoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarSexoPorUf(uf?: string | null): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        return this.core.listarSexoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarEspecialidadePorUf(uf?: string | null): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        return this.core.listarEspecialidadePorUf(uf).pipe(catchError(this.handleError));
    }

    listarNascimentoPorUf(uf?: string | null): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        return this.core.listarNascimentoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarCpfPorUf(uf?: string | null): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        return this.core.listarCpfPorUf(uf).pipe(catchError(this.handleError));
    }

    listarFormacaoPorUf(uf?: string | null): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        return this.core.listarFormacaoPorUf(uf).pipe(catchError(this.handleError));
    }

    listarAnalitico(indicadorId: string, uf?: string | null, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.listarAnalitico(indicadorId, uf, page, size).pipe(catchError(this.handleError));
    }
}
